// extracted by mini-css-extract-plugin
export default {"inactive":"resident-status-toggle_inactive__v9+JM"};